(function() {
  'use strict';

  var BREAKPOINT = 1200;

  function elements() {
    return {
      toggle: document.querySelector('.js-mobile-nav-toggle'),
      drawer: document.querySelector('.mobile-nav-wrapper'),
      header: document.querySelector('.site-header')
    };
  }

  function setOpen(open) {
    var el = elements();
    if (!el.toggle || !el.drawer || !el.header) return;

    el.drawer.classList.toggle('js-menu--is-open', open);
    el.drawer.style.transform = open
      ? 'translateY(' + el.header.getBoundingClientRect().height + 'px)'
      : 'translateY(-100%)';
    el.toggle.classList.toggle('mobile-nav--close', open);
    el.toggle.classList.toggle('mobile-nav--open', !open);
    el.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('.js-mobile-nav-toggle');
    if (!toggle || window.innerWidth >= BREAKPOINT) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setOpen(!toggle.classList.contains('mobile-nav--close'));
  }, true);

  window.addEventListener('resize', function() {
    if (window.innerWidth >= BREAKPOINT) setOpen(false);
  });
})();
